import { QUERY_PROGRESS_FAILED } from "core/consts";
import { useToast } from "dsl/atoms/ToastNotificationContext";
import { useEffect } from "react";
import { FormWatcher, isValid } from "react-forms-state";
import { useTranslations } from "translations";

type ShowNotificationEvent = (validation: AnyObject) => void;

export const getMessage = (
  validation: AnyObject,
  message: string,
  details?: boolean,
) =>
  details
    ? `${message} : ${JSON.stringify(
        validation?.infos && typeof validation.infos === "object"
          ? Object.keys(validation?.infos)
              .filter((s) => validation.infos[s] != true)
              .join(", ")
          : validation,
      )}`
    : message;

export function ValidationNotification({
  details,
  message,
  onShowNotification,
  validation,
}: {
  details?: boolean;
  message?: string;
  onShowNotification?: ShowNotificationEvent;
  validation: AnyObject;
}) {
  const translations = useTranslations();

  const toast = useToast();
  useEffect(() => {
    if (!isValid(validation)) {
      const text = message || translations.actions.validationError;

      toast({
        color: "danger",
        message: getMessage(validation, text, details),
      });

      if (onShowNotification) {
        onShowNotification(validation);
      }
    }
  }, [validation]);

  return null;
}

export const FormValidationNotification = ({
  details,
  message,
  onShowNotification,
}: {
  details?: boolean;
  message?: string;
  onShowNotification?: ShowNotificationEvent;
}) => (
  <FormWatcher watchPath="">
    {({ validation }: { validation: AnyObject }) => (
      <ValidationNotification
        details={details}
        message={message}
        validation={validation}
        onShowNotification={onShowNotification}
      />
    )}
  </FormWatcher>
);

export function ErrorNotification({
  message,
  queryProgress,
}: {
  message: string;
  queryProgress: string;
}) {
  const toast = useToast();

  useEffect(() => {
    if (queryProgress === QUERY_PROGRESS_FAILED) {
      toast({ color: "primary", message });
    }
  }, [queryProgress, message]);

  return null;
}
